// PrivateRoute.tsx
import { Navigate, Outlet } from "react-router-dom";
import DefaultLayout from "../layouts/DefaultLayout";
import authManager from "../services/auth/AuthManager";

interface PrivateRouteProps {
  Layout: any;
}

const PrivateRoute = ({ Layout = DefaultLayout }: PrivateRouteProps) => {
  if (authManager.isLoggedIn()) {
    return (
      <Layout>
        <Outlet />
      </Layout>
    );
  } else {
    return <Navigate to="/login" replace={true} />;
  }
};

export default PrivateRoute;
